module.exports = __webpack_public_path__ + "img/IC_Vacaciones_Reunion.12da5a28.svg";